import React, { useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Autocomplete, Box, Button, FormControl, Grid, InputLabel, MenuItem, Modal, Select, TextField, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow: 'auto',
    maxHeight: '80%',
};

export default function ActivityLogs() {
    const [data, setData] = useState([]);
    const [activityModal, setActivityModal] = useState(false);
    const [activityData, setActivityData] = useState('');
    const [totalResults, setTotalResults] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });

    const pageOption = [10, 25, 50, 100];

    useEffect(() => {
        getScheduleData();
    },[paginationModel]);

    const getScheduleData = async() => {
        try {
            const logResponse = await apiService.get('/report/getActivityLogs', {
                params: {
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });

            setData(logResponse?.data?.activityLogs);
            setTotalResults(logResponse?.data?.totalResults);
        } catch (error) {
            console.error(error);
        }
    }

    const getTriggerRow = (params) => {
        const data = params?.row?.changes;
        
        if(data) {
            setActivityModal(true);
            setActivityData(data);
        }
    }

    const RenderData = ({ data }) => {
        if (Array.isArray(data)) {
            return (
                <ul>
                    {data.map((item, index) => (
                        <li key={index}>
                            <RenderData data={item} />
                        </li>
                    ))}
                </ul>
            );
        } else if (typeof data === "object" && data !== null) {
            return (
                <div style={{ marginLeft: "20px" }}>
                    {Object.entries(data).map(([key, value]) => (
                        <div key={key}>
                            <strong>{key}:</strong> <RenderData data={value} />
                        </div>
                    ))}
                </div>
            );
        } else {
            return <span>{data}</span>;
        }
    };

    return (
        <div style={{ height: '75vh', width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                ACTIVITY LOGS
            </Typography>
            <DataGridPro
                getRowId={(row) => row._id}
                rows={data}
                onCellClick={getTriggerRow}
                disableDensitySelector
                columns={[
                    {   field: 'timestamp',
                        headerName: 'Date',
                        flex: 1,
                        valueFormatter: (params) => new Date(params.value).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
                    },
                    { field: 'type', headerName: 'Section', flex: 1 },
                    { field: 'performedBy', headerName: 'User', flex: 1 },
                    { field: 'performedByEmail', headerName: 'User Email', flex: 1 },
                    { field: 'action', headerName: 'Action', flex: 1 },
                    { field: 'message', headerName: 'Description', flex: 3 },
                    // { field: 'activity', headerName: 'Activity', flex: 1, valueGetter: (params) => JSON.stringify(params?.row?.details?.details) },
                ]}
                pagination
                paginationModel={paginationModel}
                rowCount={totalResults}
                paginationMode="server"
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={pageOption} 
            />

            <Modal
                open={activityModal}
                onClose={() => setActivityModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div>
                        {Object.entries(activityData).map(([key, value]) => (
                            <div key={key}>
                                <strong>{key}:</strong> <RenderData data={value} />
                            </div>
                        ))}
                        <div style={{ textAlign: 'center' }}>
                            <Button variant="outlined" sx={{ marginRight: '10px' }} onClick={() => setActivityModal(false)}>Close</Button>
                        </div>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
